import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-agent-badge',
  template: `
    <span class="agent-badge" [style.background]="color + '18'" [style.color]="color"
          [style.border-color]="color">
      <span class="agent-badge__icon">{{ icon }}</span>
      <span class="agent-badge__name">{{ name }}</span>
    </span>
  `,
  styles: [`
    .agent-badge {
      display: inline-flex; align-items: center; gap: 4px;
      padding: 3px 10px; border-radius: 999px; font-size: 12px;
      font-weight: 600; border: 1px solid; white-space: nowrap;
    }
    .agent-badge__icon { font-size: 14px; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBadgeComponent {
  @Input() icon = '';
  @Input() name = '';
  @Input() color = '#00C48C';
}
